module.exports = __webpack_public_path__ + "img/childu-txt.429df499.png";